import { render } from "./dialog-change-password.vue?vue&type=template&id=1df4f518"
import script from "./dialog-change-password.vue?vue&type=script&lang=js"
export * from "./dialog-change-password.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/storage-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__